import { render } from "./refill.vue?vue&type=template&id=5bd0d727&scoped=true&ts=true"
import script from "./refill.vue?vue&type=script&lang=ts"
export * from "./refill.vue?vue&type=script&lang=ts"

import "./refill.vue?vue&type=style&index=0&id=5bd0d727&lang=less&scoped=true"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bd0d727"]])

export default __exports__